import type GameUserStrapi from "~/libs/interfaces/GameUserStrapi";
import type GameUserLocal from "~/libs/interfaces/GameUserLocal";
import gameLocalFactory from "~/libs/factories/GameLocalFactory";
import userLocalFactory from "~/libs/factories/UserLocalFactory";

const gameUserLocalFactory = {
  createGameUserFromStrapi(gameUser?: GameUserStrapi): GameUserLocal | undefined {
    if (!gameUser) {
      return undefined;
    }
   
    return {
      id: gameUser.id,
      documentId: gameUser.documentId,

      createdAt: gameUser.createdAt ? new Date(gameUser.createdAt) : undefined,
      updatedAt: gameUser.updatedAt ? new Date(gameUser.updatedAt) : undefined,
      publishedAt: gameUser.publishedAt ? new Date(gameUser.publishedAt) : undefined,

      subscriptionDatetime: gameUser.subscriptionDatetime ? new Date(gameUser.subscriptionDatetime) : undefined,

      user: userLocalFactory.createUserFromStrapi(gameUser.user),
      game: gameLocalFactory.createGameFromStrapi(gameUser.game),
    }
  }
}
export default gameUserLocalFactory